const PIXEL_ID = process.env.REACT_APP_META_PIXEL_ID;
const CONSENT_KEY = "ca_tracking_consent";

let initialized = false;
let lastPageViewPath = null;
const listeners = new Set();

export const getConsent = () => localStorage.getItem(CONSENT_KEY);
export const onConsentChange = (fn) => { listeners.add(fn); return () => listeners.delete(fn); };

export const setConsent = (value) => {
  localStorage.setItem(CONSENT_KEY, value);
  if (value === "granted") initPixel();
  if (initialized) window.fbq("consent", value === "granted" ? "grant" : "revoke");
  listeners.forEach((fn) => fn(value));
};

const canTrack = () => initialized && getConsent() === "granted";

export const initPixel = () => {
  if (initialized || !PIXEL_ID || getConsent() !== "granted") return false;
  /* eslint-disable */
  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
  n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
  document,'script','https://connect.facebook.net/en_US/fbevents.js');
  /* eslint-enable */
  window.fbq("set", "autoConfig", false, PIXEL_ID);
  window.fbq("init", PIXEL_ID);
  initialized = true;
  return true;
};

export const trackPageView = (path) => {
  if (!canTrack() || path === lastPageViewPath) return;
  lastPageViewPath = path;
  window.fbq("track", "PageView");
};

export const trackLead = (contentName) => {
  if (!canTrack()) return;
  window.fbq("track", "Lead", { content_name: contentName });
};
